import { motion } from "framer-motion";
import { MessageCircle, Mail, Calendar, Linkedin, Instagram } from "lucide-react";
import { CONTACT } from "../data/site";

const channels = [
  { label: "WhatsApp", sub: "Fastest reply", href: CONTACT.whatsapp, icon: MessageCircle, testid: "contact-whatsapp" },
  { label: "Email", sub: "arnavbansal05@gmail.com", href: CONTACT.email, icon: Mail, testid: "contact-email" },
  { label: "Book a Call", sub: "15-min intro", href: CONTACT.call, icon: Calendar, testid: "contact-call" },
  { label: "LinkedIn", sub: "/in/arnnavk", href: CONTACT.linkedin, icon: Linkedin, testid: "contact-linkedin" },
  { label: "Instagram", sub: "@charming_chaos07", href: CONTACT.instagram, icon: Instagram, testid: "contact-instagram" },
];

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="bg-[#0047FF] text-white py-24 md:py-32 pb-32 md:pb-32 relative noise scroll-mt-16">
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <motion.h2
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="font-display font-black tracking-tighter text-[13vw] sm:text-6xl md:text-8xl leading-[0.95]"
      >
        Got a brand?
        <br />
        <span className="text-[#FFB6C1]">Let's make it loud.</span>
      </motion.h2>
      <p className="mt-6 text-white/90 max-w-md text-base md:text-lg">
        Tell me what you're building. I'll reply within 24 hours with honest thoughts, for free.
      </p>

      <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
        {channels.map((c, i) => (
          <motion.a
            key={c.label}
            href={c.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={c.testid}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.07 }}
            className="group bg-white/10 hover:bg-white rounded-lg p-6 border border-white/15 transition-colors duration-300"
          >
            <c.icon size={22} className="text-[#FFB6C1] group-hover:text-[#0047FF] transition-colors" />
            <p className="font-display font-bold mt-4 group-hover:text-[#0A0A0A] transition-colors">{c.label}</p>
            <p className="text-xs text-white/80 group-hover:text-black/50 mt-1 transition-colors">{c.sub}</p>
          </motion.a>
        ))}
      </div>

      <div className="mt-20 md:mt-24 pt-8 border-t border-white/15 flex flex-col md:flex-row justify-between gap-4 text-sm text-white/50">
        <p className="font-display font-black text-white text-lg tracking-[-0.06em] leading-none flex items-baseline select-none">
          arnav
          <span className="relative ml-1.5 inline-block w-2 h-2" aria-hidden="true">
            <span className="absolute inset-0 rounded-full bg-[#FFB6C1] translate-x-[3.5px]" />
            <span className="absolute inset-0 rounded-full bg-white" />
          </span>
        </p>
        <p>© {new Date().getFullYear()} Arnav · Branding & Marketing. Built to convert.</p>
      </div>
    </div>
  </section>
);
